import React from 'react';
import { useTicketCollection } from '../hooks/useTicketCollection';
import './freeTicketTimer.css';
import { useTranslation } from 'react-i18next';

const FreeTicketTimer = () => {
  const { t } = useTranslation();
  const { isAvailable, getTimeRemainingString, isLoading } = useTicketCollection();

  if (isLoading) {
    return (
      <div className="free-ticket-info">
        {t('common.loading', 'Loading…')}
      </div>
    );
  }

  if (isAvailable) {
    return (
      <div className="free-ticket-info available">
        <span className="ticket-available-text">{t('tickets.free_available', 'Free ticket available!')}</span>
      </div>
    );
  }

  const timeString = getTimeRemainingString();
  
  if (!timeString) {
    return (
      <div className="free-ticket-info">
        {t('tickets.checking', 'Checking availability…')}
      </div>
    );
  }

  return (
    <div className="free-ticket-info">
      {t('tickets.get_free', 'Get Free')} <img src="/ticket_icon.png" alt={t('reward.ticket', 'Ticket')} className="ticket-inline-icon" /> {t('tickets.in', 'in:')}{' '}
      <img src="/clock.svg" alt="" className="clock-inline-icon" />
      <span className="timer-text">{timeString}</span>
    </div>
  );
};

export default FreeTicketTimer;



